import React, { useEffect, useState } from 'react';
import { getMerk } from '../utils/Filter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

const FilterInsight = ({ id, option, selected, onChange, label, onRemove, count }) => {
  const [merk, setMerk] = useState([]);

  useEffect(() => {
    getMerk().then((value) => {
      setMerk(value);
    });
  }, []);

  return (
    <div className="container-fluid mt-3 px-0">
      <div className="row">
        <div className="col-xl-12 d-flex flex-row">
          <h6 className="text-secondary ml-1 mr-2" style={{ fontSize: 12 }}>
            {label}
          </h6>
          {count > 1 && (
            <FontAwesomeIcon
              onClick={() => {
                onRemove({ id });
              }}
              style={{ fontSize: 10, color: 'red', marginTop: 2 }}
              icon={faTimes}
            />
          )}
        </div>
      </div>
      <div className="row">
        <div className="col-xl-4 mt-3">
          <select
            selected={selected.brand}
            name="merk"
            onChange={(event) => {
              onChange({ event, id });
            }}
            className="form-control"
          >
            {merk.length === 0 ? (
              <option>Pilih Merek</option>
            ) : (
              merk.map((item, i) => {
                return (
                  <option key={i} selected={selected.brand === item.value} value={item.value}>
                    {item.label}
                  </option>
                );
              })
            )}
          </select>
          {(selected.brand === '' || selected.brand === 'label') && (
            <p className="text-danger ml-3 mb-0">
              <small>Pilih merk</small>
            </p>
          )}
        </div>
        <div className="col-xl-4 mt-3">
          <select
            selected={selected.series}
            name="seri"
            onChange={(event) => {
              onChange({ event, id });
            }}
            className="form-control"
            disabled={selected.brand !== '' ? false : true}
          >
            {option.series.length === 0 ? (
              <option>Pilih Seri</option>
            ) : (
              option.series.map((item, i) => {
                return (
                  <option key={i} selected={selected.series === item.value} value={item.value}>
                    {item.label}
                  </option>
                );
              })
            )}
          </select>
        </div>
        <div className="col-xl-4 mt-3">
          <select
            selected={selected.type}
            name="tipe"
            onChange={(event) => {
              onChange({ event, id });
            }}
            className="form-control"
            disabled={selected.series !== '' ? false : true}
          >
            {option.type.length === 0 ? (
              <option>Pilih Tipe</option>
            ) : (
              option.type.map((item, i) => {
                return (
                  <option key={i} selected={selected.type === item.value} value={item.value}>
                    {item.label}
                  </option>
                );
              })
            )}
          </select>
        </div>
        <div className="col-xl-4 mt-3">
          <select
            selected={selected.cylinder}
            name="silinder"
            onChange={(event) => {
              onChange({ event, id });
            }}
            className="form-control"
            disabled={selected.type !== '' ? false : true}
          >
            {option.cylinder.length === 0 ? (
              <option>Pilih Silinder</option>
            ) : (
              option.cylinder.map((item, i) => {
                return (
                  <option key={i} elected={selected.cylinder === item.value} value={item.value}>
                    {item.label}
                  </option>
                );
              })
            )}
          </select>
        </div>
        <div className="col-xl-4 mt-3">
          <select
            selected={selected.year}
            name="tahun"
            onChange={(event) => {
              onChange({ event, id });
            }}
            className="form-control"
            disabled={selected.cylinder !== '' ? false : true}
          >
            {option.year.length === 0 ? (
              <option>Pilih Tahun</option>
            ) : (
              option.year.map((item, i) => {
                return (
                  <option key={i} selected={selected.year == item.value} value={item.value}>
                    {item.label}
                  </option>
                );
              })
            )}
          </select>
        </div>
        <div className="col-xl-4 mt-3">
          <select
            selected={selected.city}
            name="kota"
            onChange={(event) => {
              onChange({ event, id });
            }}
            className="form-control"
            disabled={selected.cylinder !== '' ? false : true}
          >
            {option.city.length === 0 ? (
              <option>Pilih Kota</option>
            ) : (
              option.city.map((item, i) => {
                return (
                  <option key={i} selected={selected.city === item.value} value={item.value}>
                    {item.label}
                  </option>
                );
              })
            )}
          </select>
        </div>
        <div className="col-xl-4 mt-3">
          <select
            selected={selected.transmission}
            name="transmisi"
            onChange={(event) => {
              onChange({ event, id });
            }}
            className="form-control"
            disabled={selected.city !== '' ? false : true}
          >
            {option.transmission.length === 0 ? (
              <option>Pilih Transmisi</option>
            ) : (
              option.transmission.map((item, i) => {
                return (
                  <option key={i} selected={selected.transmission === item.value} value={item.value}>
                    {item.label}
                  </option>
                );
              })
            )}
          </select>
        </div>
        <div className="col-xl-4 mt-3">
          <select
            selected={selected.grade}
            name="grade"
            onChange={(event) => {
              onChange({ event, id });
            }}
            className="form-control"
            disabled={selected.transmission !== '' ? false : true}
          >
            {option.grade.length === 0 ? (
              <option>Pilih Grade</option>
            ) : (
              option.grade.map((item, i) => {
                return (
                  <option key={i} selected={selected.grade === item.value} value={item.value}>
                    {item.label}
                  </option>
                );
              })
            )}
          </select>
        </div>
      </div>
      {/* <div className="row mt-3">
                
            </div>
            <div className="row mt-3">
                
            </div> */}
    </div>
  );
};

export default FilterInsight;
